export default "__VITE_PUBLIC_ASSET__8e97aee8__"